module.exports = __webpack_public_path__ + "img/logo.1338a078.png";